import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { TableUi } from "../../../../ui/TableUi";

const columns = (props) => {
  const { form } = props;
  return [
    {
      title: "N°",
      dataIndex: "nro",
      key: "nro",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Serie",
      dataIndex: "numero_serie",
      key: "numero_serie",
      render: (text, record, index) => (
        <>{form.getFieldValue(["series", record?.name, "numero_serie"])}</>
      ),
    },
    {
      title: "Fecha fabricación",
      dataIndex: "fecha_fabricacion",
      key: "fecha_fabricacion",
      render: (text, record, index) => (
        <>{form.getFieldValue(["series", record?.name, "fecha_fabricacion"])}</>
      ),
    },
  ];
};
export const DetalleSalidaSerieTable = ({ data, openModal }) => {
  const form = Form.useFormInstance();
  const series = form.getFieldValue("series");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    series.forEach((item, index) => {
      if (newSelectedRowKeys.includes(index)) {
        item.selected = true;
      } else item.selected = false;
    });
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  useEffect(() => {
    const indexSelected = [];
    if (openModal) {
      series?.forEach((item, index) => {
        if (item.selected === true) {
          indexSelected.push(index);
        }
      });
      setSelectedRowKeys(indexSelected);
    }
  }, [openModal]);

  return (
    <TableUi
      rowSelection={{ ...rowSelection }}
      data={data}
      columns={columns({ form })}
      size="small"
    />
  );
};
